import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './law-enforcement/HeroSection';
import { IntroSection } from './law-enforcement/IntroSection';
import { PremierProgramsSection } from './law-enforcement/PremierProgramsSection';
import { UseOfForceSection } from './law-enforcement/UseOfForceSection';
import { EducatingSection } from './law-enforcement/EducatingSection';
export function LawEnforcementPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-803">
      <Navbar data-id="element-804" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-805">
        <HeroSection data-id="element-806" />
        <IntroSection data-id="element-807" />
        <PremierProgramsSection data-id="element-808" />
        <UseOfForceSection data-id="element-809" />
        <EducatingSection data-id="element-810" />
      </main>
      <Footer data-id="element-811" />
    </div>;
}